import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class CrmOpportunityService extends Service {
	constructor(injector: Injector) {
		super("CrmOpportunity", injector);
	}

	getByClientId(clientId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByClientId/${clientId}`);
	}

	getByLeadId(leadId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByLeadId/${leadId}`);
	}

	getByStage(stage: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByStage/${stage}`);
	}
}
